import React from "react"
import { Link } from "gatsby"

const Nav = () => (
  <>
    <nav id="navbar" className="center-column">
      <Link to="/projekte" activeClassName="is-active">
        Projekte
      </Link>
      <Link to="/kompetenzen" activeClassName="is-active">
        Kompetenzen
      </Link>
      <Link to="/leistungen" activeClassName="is-active">
        Leistungen
      </Link>
      <Link to="/ueber-uns" activeClassName="is-active">
        Über uns
      </Link>
    </nav>
  </>
)

export default Nav
